import { assets } from "@/lib/assets"
import {ArrowRight} from 'lucide-react'
import WaveLines from "@/components/WaveLines"

function Hero() {
  return (
    <section id="hero" data-nav="light" className="relative min-h-screen overflow-hidden bg-[#9eb8c9] text-white">
      <div
        className="absolute inset-0 opacity-70"
        style={{
          backgroundImage: `radial-gradient(ellipse 80% 55% at 18% -10%, rgba(255,255,255,0.55), transparent 55%), linear-gradient(160deg, rgba(90,120,145,0.35), transparent 40%)`,
        }}
      />
      <div
        className="pointer-events-none absolute -left-10 top-0 h-[70%] w-[55%] opacity-50"
        style={{
          background: "linear-gradient(118deg, rgba(255,255,255,0.28) 0%, transparent 58%)",
          filter: "blur(2px)",
        }}
      />
      <WaveLines />
      <div className="grain absolute inset-0" />

      <div className="relative mx-auto flex min-h-screen max-w-6xl flex-col justify-between px-8 pb-8 pt-24 md:px-10 md:pb-12 md:pt-28">
        <div className="max-w-xl pt-8 md:pt-12">
          <div className="relative inline-block">
            <h1 className="font-serif-tc text-[64px] font-light leading-none tracking-[0.2em] md:text-[96px]">
              微光
            </h1>
            <span className="absolute -right-[calc(1.5rem+1cm)] top-1 font-serif-tc text-[12px] tracking-[0.18em] text-[#ead58c] md:-right-14 md:top-3 md:text-sm">
              江美琪
            </span>
          </div>
          <p className="mt-1 font-display text-[30px] italic tracking-[0.14em] text-white/92 md:text-[42px]">
            Inner Light
          </p>
          <p className="mt-10 font-serif-tc text-[18px] leading-9 tracking-[0.2em] md:text-[20px]">
            唱過心裡的傷，
            <br />
            走向下一束光。
          </p>
          <p className="mt-6 max-w-[220px] text-[13px] font-light leading-7 tracking-[0.06em] text-white/78">
            一段演出結束了，
            <br />
            氣味替我們留下
            <br />
            那些還沒說完的情緒。
          </p>
          <a
            href="#product"
            className="mt-9 inline-flex items-center gap-3 rounded-full border border-white/75 px-6 py-2.5 text-[12px] tracking-[0.24em] transition hover:bg-white hover:text-[#2d4658]"
          >
            立即收藏
            <ArrowRight size={14} />
          </a>
        </div>

        <div className="relative mt-6 flex items-end justify-between">
          <img
            src={assets.productSet}
            alt="微光限定禮盒與香水"
            className="w-full max-w-2xl object-contain drop-shadow-[0_24px_40px_rgba(20,35,50,0.35)] md:w-[58%]"
          />
          <span className="absolute bottom-4 right-0 hidden text-[10px] tracking-[0.42em] text-white/45 md:block">
            SCROLL
          </span>
        </div>
      </div>
    </section>
  )
}

export default Hero
